<template>
    <form-container :header="translate('externalSignerImport.externalSigners')" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{translate('externalSigner.name')}}</label>
                    <input @input="checkInput('Name',$event)" v-model="data.Name" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>{{translate('externalSigner.surname')}}</label>
                    <input @input="checkInput('Surname',$event)" v-model="data.Surname" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>{{translate('externalSigner.email')}}</label>
                    <input @input="checkInput('Email',$event)" v-model="data.Email" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>{{translate('draftEyp.phone')}}</label>
                    <input @input="checkInput('Phone',$event)" v-model="data.Phone" type="number" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>{{translate('certificateItemV2.tckn')}}</label>
                    <IdentityNumber v-if="!loading" :id-defined="data.IsIdentityNumberDefined" v-model="data.IdentityNumber" class="form-control" maxlength="11" minlength="11" />
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button"  v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                </div> 
                <div class="col text-right mlxs">
                    <button type="submit" class="btn btn-success" :disabled="kaydetDisabled">{{translate('save')}}</button>
                </div>
            </div>
        </template>

    </form-container>
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import IdentityNumber from '../components/IdentityNumber.vue'

export default {
    mixins: [formMixin],
    components: {
        formContainer,
        IdentityNumber
        //stepViewer
    },
    created(){
        this.getData(this.$route.params.id).then(() => {
            this.loading = false
        });
    },
    data() {
        return {
            loading: true,
            modelName: 'ExternalSigner',
            kaydetDisabled: false,
            data: {},
        }
    },
    watch: {
        'data.IdentityNumber'(oldValue){
            if(oldValue.length != 11 && oldValue.length != 0){
                this.kaydetDisabled = true
                console.log(oldValue)
            }else{
                this.kaydetDisabled = false
            }
        }
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
    },
}
</script>